import { Card, CloseButton, IconArrowOpenDownLine, IconArrowOpenUpLine, IconButton, Text, View } from '@smarterservices/smarter-ui';
import { ParamsNotFoundError } from '../../../helpers/definedErrors';
import React, { useState, useEffect } from 'react';
import { collapseIframe, expandIframe, removeExamPassword } from '../../../helpers/helpers';

const ExamPassword = () => {
  const [sessionSid, setSessionSid] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const initExamPassword = async () => {
      const url = new URL(window.location.href);
      const examPasswordQueryParams = new Proxy(new URLSearchParams(url.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      if (!examPasswordQueryParams.sessionSid) {
        throw new ParamsNotFoundError();
      }
      setSessionSid(examPasswordQueryParams.sessionSid);
      const isExpanded = examPasswordQueryParams.isExpanded === 'true';
      setIsExpanded(isExpanded);
    };
    initExamPassword();
  }, []);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
    if (isExpanded) {
      collapseIframe('spExamPasswordIframeId');
    } else {
      expandIframe('spExamPasswordIframeId');
    }
  };

  return sessionSid ? (
    <Card
      background="secondary"
      borderColor="brand"
      borderWidth="large"
      borderRadius="x-small"
    >
      <Card.Header background="brand">
        <Card.Title>Exam Password</Card.Title>
        <Card.Actions>
          {isExpanded ? (
            <IconButton
              withBackground={false}
              withBorder={false}
              margin="small"
              size="small"
              color="primary-inverse"
              screenReaderLabel="Collapse"
              focusColor="inverse"
              onClick={toggleExpand}
            >
              <IconArrowOpenUpLine />
            </IconButton>
          ) : (
            <IconButton
              withBackground={false}
              withBorder={false}
              margin="small"
              size="small"
              color="primary-inverse"
              screenReaderLabel="Expand"
              focusColor="inverse"
              onClick={toggleExpand}
            >
              <IconArrowOpenDownLine />
            </IconButton>
          )}
          <CloseButton
            color="primary-inverse"
            screenReaderLabel="Close"
            onClick={removeExamPassword}
          />
        </Card.Actions>
      </Card.Header>
      { isExpanded && (
        <Card.Body padding="medium" height="100%" overflowY="auto">
          <View as="div" margin="small 0 0 0">
            <View as="span" margin="0 0 small 0">
              <Text size="medium">
                The unique password for this exam is:
              </Text>
            </View>
            <View
              as="span"
              background="primary"
              borderWidth="small"
              borderColor="brand"
              borderRadius="medium"
              padding="xxx-small"
              margin="0 0 0 small"
              textAlign="center"
              display="inline-block"
              minWidth="120px"
            >
              <Text size="large" weight="bold" color="primary">
                {sessionSid ? `sp${sessionSid.slice(-5)}` : ''}
              </Text>
            </View>
          </View>
          <View as="div" margin="large 0 0 0">
            <Text size="small" color="secondary">
              Tips: If this window covers the password field, move it by clicking and dragging the six dots at the top. The password must be typed exactly as shown; the ability to copy and paste is not available.
            </Text>
          </View>
        </Card.Body>
      )}
    </Card>
  ) : null;
};

export default ExamPassword;